import { SelectChangeEvent } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { SelectOptionValue } from '../../Select/select.types';
import { hasSameValues } from '../../inlineEdit.utils';
import { InlineEditSelectProps } from '../inlineEditSelect.types';

const isEscapeEvent = (event: SyntheticEvent) => (event as { key?: string }).key === 'Escape';

export const useInlineEditSelect = (props: InlineEditSelectProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValues, setDraftValues] = useState<SelectOptionValue[]>([]);

  const selectedValues = props.multiple ? props.value : [props.value];
  const selectedOptions = props.options.filter((option) => selectedValues.includes(option.value));

  const handleStartEditing = () => {
    if (props.isDisabled) {
      return;
    }

    if (props.multiple) {
      setDraftValues(props.value);
    }

    setIsEditing(true);
  };

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    if (props.multiple) {
      setDraftValues(event.target.value as SelectOptionValue[]);
      return;
    }

    setIsEditing(false);

    const nextValue = event.target.value as SelectOptionValue;

    if (nextValue === props.value) {
      return;
    }

    props.onConfirm(nextValue);
  };

  const handleClose = (event: SyntheticEvent) => {
    setIsEditing(false);

    if (!props.multiple || isEscapeEvent(event) || hasSameValues(draftValues, props.value)) {
      return;
    }

    props.onConfirm(draftValues);
  };

  return {
    isEditing,
    draftValues,
    selectedOptions,
    handleStartEditing,
    handleChange,
    handleClose,
  };
};
